import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/auth/user.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: []
})
export class LoginComponent implements OnInit {
    formModel = {
        UserName: '',
        Password: ''
    }

    constructor(
        private service: UserService,
        private toastr: ToastrService,
    ) { }

    ngOnInit() {
        if (localStorage.getItem('logged'))
            window.location.href = "/techbyte/admin";
    }

    onSubmit(form: NgForm) {
        this.service.login(form.value).subscribe(
            (res: any) => {
                localStorage.setItem("logged", "true");
                window.location.href = "/techbyte/admin";
            },
            err => {
                if (err.status == 400)
                    this.toastr.error('Tên đăng nhập hoặc tài khoản không chính xác.', 'Xác thực thất bại.');
                else
                    console.log(err);
            }
        );
    }
}